import { render, staticRenderFns } from "./FootBanner.vue?vue&type=template&id=02e07f08&scoped=true"
import script from "./FootBanner.vue?vue&type=script&lang=js"
export * from "./FootBanner.vue?vue&type=script&lang=js"
import style0 from "./FootBanner.vue?vue&type=style&index=0&id=02e07f08&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e07f08",
  null
  
)

export default component.exports